function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "icon",
  d: "M22.6753 0H1.32467C0.973344 0 0.636409 0.139563 0.387986 0.387986C0.139563 0.636409 0 0.973344 0 1.32467V22.6757C8.8391e-05 23.0269 0.13969 23.3638 0.388104 23.6121C0.636517 23.8605 0.973401 24 1.32467 24H12.819V14.706H9.69133V11.084H12.819V8.41267C12.819 5.31267 14.7123 3.625 17.4777 3.625C18.8023 3.625 19.9407 3.72333 20.2727 3.76767V7.00733L18.3547 7.00833C16.8507 7.00833 16.5597 7.723 16.5597 8.77167V11.0843H20.1463L19.6793 14.7063H16.5597V24H22.6757C23.0269 23.9999 23.3638 23.8603 23.6121 23.6119C23.8605 23.3635 24 23.0266 24 22.6753V1.32467C24 0.973344 23.8604 0.636409 23.612 0.387986C23.3636 0.139563 23.0267 0 22.6753 0Z",
  fill: "white"
});

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.bbb3dca0.svg";
export { ForwardRef as ReactComponent };